﻿export class IntegerModel {
    value?: number;
    
}

export class DecimalModel {
    value?: number;
}

export class ResetPasswordSuccessModel {
    value?: number;
    custUrl?: string;
    constructor() {
        this.value = 0;
        this.custUrl = "";
    }
}

